<script>
import tableColumns, {fieldMap, formatField} from "./config.js"
import {request} from "@/config/request";
import {resetEmpty} from "@/utils/common";
export default {
  name: "RecommendEdit",
  data() {
    return {
      tableForm: [{name: ""}], // 占位使用
      formConfigList: tableColumns,
      formData: {},
      dataList: [],
    }
  },
  methods: {
    // 编辑提交
    async handleEditSubmit() {
      try {
        const paramsList = this.dataList.map(item => {
          return {
            code: item.code,
            elementValue:  this.formData[item.keyName],
            elementValue2:  item.keyName === "totalFat" ? this.formData["totalFatArea"] : null,
          }
        })
        await request(this.$api.recommendCalorie.edit, paramsList, {isJson: true});
        this.$message.success(this.$t('操作成功'));
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },

    // 重置
    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
      this.formData.age = this.$route.query.age;
    },

    // 加载详情
    async handleLoadDetail() {
      try {
        const res = await request(this.$api.recommendCalorie.detail, this.$route.query);
        const infoList = res.recommendCalories;
        infoList.forEach(item => {
          const name = formatField(item);
          item.keyName = fieldMap[name];
          if(item.keyName === "totalFat") {
            item["totalFatArea"] = item.elementValue2;
            this.formData["totalFatArea"] = item.elementValue2;
          }
          this.formData[item.keyName] = item.elementValue;
        })
        this.dataList = infoList;
        this.formData.age = this.$route.query.age;
        console.log("form", this.formData)
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    Object.values(fieldMap).forEach(item => {
      this.$set(this.formData, item, "");
    })
    this.$set(this.formData, "totalFatArea", "");
    this.handleLoadDetail();
  }
}
</script>

<template>
  <el-card>
    <el-form label-width="auto" label-position="left" :model="formData" ref="form">
      <template v-for="(item, index) in formConfigList">
        <!--   表格  -->
        <el-form-item v-if="item.tableColumn && item.tableColumn.length" :key="index" :label="$t(item.label) + '：'">
          <el-table :data="tableForm">
            <el-table-column v-for="(t, tIndex) in item.tableColumn" :key="tIndex" :label="$t(t.label)" align="center">
              <el-table-column v-for="(tc, tcIndex) in t.children" :key="tcIndex" :label="$t(tc.label)" align="center">
                <template v-slot="{row}">
                  <el-input :placeholder="$t(tc.label)" v-model="formData[tc.prop]" />
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-form-item>

        <!--   普通表单  -->
        <template v-else>
          <!--   分男女  -->
          <el-form-item class="form-item" :label="$t(item.label) + '：'" :key="index" v-if="item.children.length">
            <div style="display: flex;column-gap: 16px">
              <el-form-item
                  v-for="(c, cIndex) in item.children"
                  :key="cIndex"
                  :label="$t(c.label) + '：'"
                  :prop="c.prop"
                  label-width="30px"
                  class="flex">
                <el-input :placeholder="$t('请输入')" v-model="formData[c.prop]" />
              </el-form-item>
            </div>
          </el-form-item>

          <!--   总脂肪  -->
          <el-form-item class="form-item" :label="$t(item.label) + '：'" :key="index" v-else-if="item.prop === 'totalFat'">
            <div style="display: flex;column-gap: 16px">
              <el-form-item
                  prop="totalFat"
                  label-width="0px">
                <el-input :placeholder="$t('请输入')" v-model="formData.totalFat" />
              </el-form-item>
              <span>~</span>
              <el-form-item
                  prop="totalFatArea"
                  label-width="0px"
                  class="flex">
                <el-input :placeholder="$t('请输入')" v-model="formData.totalFatArea" />
              </el-form-item>
            </div>
          </el-form-item>


          <!--   不分男女  -->
          <el-form-item
              class="form-item"
              :label="$t(item.label) + '：'"
              :prop="item.prop"
              :key="index"
              v-else>
            <el-input :placeholder="$t('请输入')" v-model="formData[item.prop]" :disabled="item.disabled || false" />
          </el-form-item>
        </template>
      </template>

      <el-form-item label-width="30px">
        <el-button type="primary" @click="handleEditSubmit">{{$t('保存')}}</el-button>
        <el-button @click="$router.back()">{{$t('返回')}}</el-button>
      </el-form-item>

    </el-form>
  </el-card>
</template>

<style scoped>

.el-form {
  width: 50vw;
}

.form-item {
  width: 50%;
}

.flex {
  flex: 1;
}


</style>
